__turbopack_context__.v({
  "floatContainer": "FloatButton-module__EGOS3a__floatContainer",
  "socialButton": "FloatButton-module__EGOS3a__socialButton",
});
